import {DatabaseURL} from "../../App";
import {errorActions} from "../ErrorHandler/errorHandler";
import {headers} from "../../../_metronic/_helpers";
import api from "../../util/api";

export const mediaItemActionTypes = {
    getVideoInfo: "getVideoInfo",
    getVideoNetgraphData: "getVideoNetgraphData",
    getVideoNetgraphConfig: "getVideoNetgraphConfig",
    getVideoNetgraphInsights: "getVideoNetgraphInsights",
    setVideoDataLoading: "setVideoDataLoading",
    setNetgraphDataLoading: "setNetgraphDataLoading",
    setNetgraphConfigLoading: "setNetgraphConfigLoading",
    setVideoTerm: "setVideoTerm",
    setIsConceptualSearch: "setIsConceptualSearch",
    getCarousel: "getCarousel",
    setCarouselLoading: "setCarouselLoading",
    getTextFileUrl: "getTextFileUrl",
    getCaptionsFileUrl: "getCaptionsFileUrl",
    clearVideo: "clearVideo",
};

const initialMediaItemState = {
    info: {},
    videoInfoError: {},
    netGraphData: [],
    netgraphDataError: {},
    videoNetgraphConfig: {},
    videoNetgraphInsights: [],
    isLoadingVideoData: false,
    netgraphDataLoading: false,
    netgraphConfigLoading: false,
    isConceptualSearch: false,
    videoTerm: {},
    carousel: [],
    carouselError: {},
    textFileUrl: null,
    textFileUrlError: {},
    captionsFileUrl: null,
    captionsFileUrlError: {},
    isLoadingCarousel: false,
};

export const mediaItemReducer = (state = initialMediaItemState, action) => {
    switch (action.type) {
        case mediaItemActionTypes.getVideoInfo: {
            const {info, videoInfoError} = action.payload;
            return {
                ...state,
                info,
                videoInfoError,
            };
        }
        case mediaItemActionTypes.getVideoNetgraphData: {
            const {netGraphData, netgraphDataError} = action.payload;

            return {
                ...state,
                netGraphData,
                netgraphDataError,
            };
        }

        case mediaItemActionTypes.getVideoNetgraphConfig: {
            const {videoNetgraphConfig} = action.payload;

            return {
                ...state,
                videoNetgraphConfig,
            };
        }

        case mediaItemActionTypes.getVideoNetgraphInsights: {
            const {videoNetgraphInsights} = action.payload;

            return {
                ...state,
                videoNetgraphInsights,
            };
        }

        case mediaItemActionTypes.getCarousel: {
            const {carousel, carouselError} = action.payload;

            return {...state, carousel, carouselError};
        }

        case mediaItemActionTypes.setCarouselLoading: {
            const {isLoadingCarousel} = action.payload;

            return {...state, isLoadingCarousel};
        }

        case mediaItemActionTypes.getTextFileUrl: {
            const {textFileUrl, textFileUrlError} = action.payload;

            return {...state, textFileUrl, textFileUrlError};
        }

        case mediaItemActionTypes.getCaptionsFileUrl: {
            const {captionsFileUrl, captionsFileUrlError} = action.payload;

            return {...state, captionsFileUrl, captionsFileUrlError};
        }


        case mediaItemActionTypes.setVideoDataLoading: {
            const {isLoadingVideoData} = action.payload;

            return {
                ...state,
                isLoadingVideoData,
            };
        }

        case mediaItemActionTypes.setNetgraphDataLoading: {
            const {netgraphDataLoading} = action.payload;

            return {
                ...state,
                netgraphDataLoading,
            };
        }

        case mediaItemActionTypes.setNetgraphConfigLoading: {
            const {netgraphConfigLoading} = action.payload;

            return {
                ...state,
                netgraphConfigLoading,
            };
        }

        case mediaItemActionTypes.setVideoTerm: {
            const {type, text, time, selectedNode} = action.payload;

            return {
                ...state,
                videoTerm: {
                    type,
                    text,
                    time,
                    selectedNode,
                },
            };
        }

        case mediaItemActionTypes.setIsConceptualSearch: {
            const {isConceptualSearch} = action.payload;
            return {...state, isConceptualSearch};
        }

        case mediaItemActionTypes.clearVideo: {
            return {
                ...initialMediaItemState,
                videoTerm: state.videoTerm,
            };
        }

        default:
            return state;
    }
};

const videoDataLoading = isLoadingVideoData => ({
    type: mediaItemActionTypes.setVideoDataLoading,
    payload: {
        isLoadingVideoData,
    },
});

const setCarouselLoading = isLoadingCarousel => ({
    type: mediaItemActionTypes.setCarouselLoading,
    payload: {isLoadingCarousel},
});

export const mediaItemPageActions = {
    getVideoInfo: (videoId, language) => dispatch => {
        if (videoId) {
            dispatch(videoDataLoading(true));
            return api
                .get(`v2/api/videos/${videoId}`, {
                    method: "GET",
                    params: {
                        language,
                    },
                    headers: headers(),
                })
                .then(({data: {data = {}, message = []}}) => {
                    dispatch(videoDataLoading(false));

                    dispatch({
                        type: mediaItemActionTypes.getVideoInfo,
                        payload: {
                            info: data,
                            videoInfoError: message && message[0],
                        },
                    });
                })
                .catch(err => {
                    console.error(err);
                    dispatch(videoDataLoading(false));
                    dispatch(errorActions.setErrorMessage(err.message));
                });
        } else {
            dispatch(videoDataLoading(false));
            dispatch(errorActions.setErrorMessage("Video ID not provided"));
        }
    },
    getVideoNetgraphData: (videoId, page, language) => dispatch => {
        dispatch({
            type: mediaItemActionTypes.setNetgraphDataLoading,
            payload: {
                netgraphDataLoading: true,
            },
        });
        return api
            .get(`v2/api/${page}/${videoId}/netgraph`, {
                method: "GET",
                params: {
                    language,
                },
                headers: headers(),
            })
            .then(({data: {data = [], message = [{}]}}) => {
                dispatch({
                    type: mediaItemActionTypes.setNetgraphDataLoading,
                    payload: {
                        netgraphDataLoading: false,
                    },
                });
                dispatch({
                    type: mediaItemActionTypes.getVideoNetgraphData,
                    payload: {
                        netGraphData: data,
                        netgraphDataError: message[0],
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: mediaItemActionTypes.setNetgraphDataLoading,
                    payload: {
                        netgraphDataLoading: false,
                    },
                });
                console.error(err);
            });
    },

    getVideoNetgraphConfig: type => dispatch => {
        dispatch({
            type: mediaItemActionTypes.setNetgraphConfigLoading,
            payload: {
                netgraphConfigLoading: true,
            },
        });
        return api
            .get(`${DatabaseURL}/api/component/${type}`)
            .then(({data}) => {
                dispatch({
                    type: mediaItemActionTypes.getVideoNetgraphConfig,
                    payload: {
                        videoNetgraphConfig: data.data[0].config,
                    },
                });
                dispatch({
                    type: mediaItemActionTypes.setNetgraphConfigLoading,
                    payload: {
                        netgraphConfigLoading: false,
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: mediaItemActionTypes.setNetgraphConfigLoading,
                    payload: {
                        netgraphConfigLoading: false,
                    },
                });
                console.error("Error on netgraph config data retriving");
            });
    },

    getVideoNetgraphInsights: (videoId, page) => dispatch => {
        return api
            .get(`v2/api/${page}/${videoId}/netgraph/features`)
            .then(({data}) => {
                dispatch({
                    type: mediaItemActionTypes.getVideoNetgraphInsights,
                    payload: {
                        videoNetgraphInsights: data.data || [],
                    },
                });
            })
            .catch(err => dispatch(errorActions.setErrorMessage(err.message)));
    },

    getCarousel: () => dispatch => {
        dispatch(setCarouselLoading(true));
        return api
            .get("/v2/api/videos/recommended")
            .then(({data}) => {
                dispatch({
                    type: mediaItemActionTypes.getCarousel,
                    payload: {
                        carousel: data?.data || [],
                        carouselError: {},
                    },
                });
                dispatch(setCarouselLoading(false));
            })
            .catch(err => {
                console.error(err);
                dispatch({
                    type: mediaItemActionTypes.getCarousel,
                    payload: {
                        carousel: [],
                        carouselError: {text: err.message},
                    },
                });
                dispatch(setCarouselLoading(false));
            });
    },
    getTextFileUrl: (videoId, language) => dispatch => {
        return api
            .get(`v2/api/videos/${videoId}/transcript/text`, {
                method: "GET",
                params: {
                    language,
                },
                headers: headers(),
            })
            .then(({data: {data = null, message = [{}]}}) => {
                dispatch({
                    type: mediaItemActionTypes.getTextFileUrl,
                    payload: {
                        textFileUrl: data,
                        textFileUrlError: message[0],
                    },
                });
            })
            .catch(err => {
                console.error(err);
            });
    },
    getCaptionsFileUrl: (videoId, language) => dispatch => {
        return api
            .get(`v2/api/videos/${videoId}/transcript/captions`, {
                method: "GET",
                params: {
                    language,
                },
                headers: headers(),
            })
            .then(({data: {data = null, message = [{}]}}) => {
                dispatch({
                    type: mediaItemActionTypes.getCaptionsFileUrl,
                    payload: {
                        captionsFileUrl: data,
                        captionsFileUrlError: message[0],
                    },
                });
            })
            .catch(err => {
                console.error(err);
            });
    },
    setVideoTerm: ({type, text, time, selectedNode}) => dispatch =>
        dispatch({
            type: mediaItemActionTypes.setVideoTerm,
            payload: {
                type,
                text,
                time,
                selectedNode,
            },
        }),

    setIsConceptualSearch: isConceptualSearch => dispatch =>
        dispatch({
            type: mediaItemActionTypes.setIsConceptualSearch,
            payload: {
                isConceptualSearch,
            },
        }),

    clear: () => dispatch =>
        dispatch({
            type: mediaItemActionTypes.clearVideo,
            payload: null,
        }),
};
